import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import GalleryItem from "../components/gallery-item";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";

export default function Gallery() {
  const { getSeoTitle, getSeoDescription } = useUtilities();
  const [gallery, setGallery] = useState([]);
  const [page, setPage] = useState({});
  const [pageMedia, setPageMedia] = useState([]);
  const [galleryMedia, setGalleryMedia] = useState([]);

  useEffect(() => {
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "gallery"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};
        setPage(pageResponse);

        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });

        axios
          .get(
            CONTENT_ROUTES.GALLERIES(
              "?order_by=menu_order&order=desc&per_page=100",
            ),
          )
          .then((res) => {
            setGallery(res.data);

            let media = [];

            res.data?.map((project, i) => {
              if (project?.featured_media)
                axios
                  .get(CONTENT_ROUTES.MEDIA_BY_ID(project?.featured_media))
                  .then((res) => {
                    media[i] = res.data;
                    setGalleryMedia((prevState) => [...prevState, media[i]]);
                  });
              return project?.featured_media;
            });
          })
          .catch((err) => {})
          .finally(() => {});
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  return (
    <>
      <Helmet>
        <title>{getSeoTitle(page, `Gallery - Nant Power`)}</title>
        <meta
          name="description"
          content={getSeoDescription(
            page,
            `Explore Nant Power's curated collection of images and videos that capture key moments, events, and experiences.`
          )}
        />
      </Helmet>

      <Header />
      <main>
        <section className="pt-16">
          <div className="container mx-auto">
            <div className="mx-auto">
              <div className="w-full">
                <div className="relative xl:px-0 px-8 text-left">
                  <h1 className="text-4xl font-medium mb-2 text-[#2c3e50]">
                    {page?.title?.rendered}
                  </h1>
                  <div
                    className="text-[#58b947] text-2xl font-medium"
                    dangerouslySetInnerHTML={{
                      __html: page?.content?.rendered,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white py-16">
          <div className="container mx-auto xl:px-0 px-8">
            <div className="grid grid-cols-1 gap-x-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
              {gallery?.map((article, i) => (
                <Fragment key={i}>
                  <GalleryItem
                    article={article}
                    galleryMedia={galleryMedia?.find(
                      (media) => media.id === article?.featured_media,
                    )}
                  />
                </Fragment>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
